import React from 'react';
import { FaBriefcase, FaChartLine, FaFileAlt, FaUsers } from 'react-icons/fa';
import { useTheme } from '../../context/SocketContext';

const CFO = () => {
  const { currentThemeColors } = useTheme();
  
  return (
    <div className="space-y-6">
      {/* Page Header */}
      <div className="opacity-0 animate-fade-in-up" style={{ animationDelay: '0ms', animationFillMode: 'forwards' }}>
        <h1 className="text-2xl font-bold text-dark-800 dark:text-white">
          <span style={{ color: 'var(--primary-500)' }}>CFO Advisory</span>
        </h1>
        <p className="text-gray-500 dark:text-gray-400 mt-1">Strategic financial guidance for your business</p>
      </div>

      {/* Coming Soon Card */}
      <div className="card p-12 text-center opacity-0 animate-fade-in-up" style={{ animationDelay: '100ms', animationFillMode: 'forwards' }}>
        <div 
          className="w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6 transition-transform duration-300 hover:scale-110"
          style={{ background: 'var(--primary-100)' }}
        >
          <FaBriefcase className="w-10 h-10" style={{ color: 'var(--primary-500)' }} />
        </div>
        <h2 className="text-2xl font-bold text-dark-800 dark:text-white mb-3">CFO Advisory Services</h2>
        <p className="text-gray-500 dark:text-gray-400 max-w-md mx-auto mb-8">
          Get expert financial guidance and strategic advice to help your business grow and succeed.
        </p>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-3xl mx-auto">
          <div className="p-4 rounded-xl bg-gray-50 dark:bg-dark-700 hover:shadow-lg hover:-translate-y-1 transition-all duration-300 cursor-pointer opacity-0 animate-fade-in-up" style={{ animationDelay: '200ms', animationFillMode: 'forwards' }}>
            <FaChartLine className="w-8 h-8 mx-auto mb-3" style={{ color: 'var(--primary-500)' }} />
            <h3 className="font-semibold text-dark-800 dark:text-white mb-1">Financial Planning</h3>
            <p className="text-sm text-gray-500 dark:text-gray-400">Strategic financial roadmaps</p>
          </div>
          <div className="p-4 rounded-xl bg-gray-50 dark:bg-dark-700 hover:shadow-lg hover:-translate-y-1 transition-all duration-300 cursor-pointer opacity-0 animate-fade-in-up" style={{ animationDelay: '300ms', animationFillMode: 'forwards' }}>
            <FaFileAlt className="w-8 h-8 mx-auto mb-3" style={{ color: 'var(--primary-500)' }} />
            <h3 className="font-semibold text-dark-800 dark:text-white mb-1">Financial Reports</h3>
            <p className="text-sm text-gray-500 dark:text-gray-400">Detailed analysis & insights</p>
          </div>
          <div className="p-4 rounded-xl bg-gray-50 dark:bg-dark-700 hover:shadow-lg hover:-translate-y-1 transition-all duration-300 cursor-pointer opacity-0 animate-fade-in-up" style={{ animationDelay: '400ms', animationFillMode: 'forwards' }}>
            <FaUsers className="w-8 h-8 mx-auto mb-3" style={{ color: 'var(--primary-500)' }} />
            <h3 className="font-semibold text-dark-800 dark:text-white mb-1">Expert Consultation</h3>
            <p className="text-sm text-gray-500 dark:text-gray-400">One-on-one advisory sessions</p>
          </div>
        </div>

        <p className="text-sm text-gray-400 dark:text-gray-500 mt-8 opacity-0 animate-fade-in-up" style={{ animationDelay: '500ms', animationFillMode: 'forwards' }}>
          Contact your administrator for more information about CFO Advisory services.
        </p>
      </div>
    </div>
  );
};

export default CFO;